"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconShield3 = void 0;
var _react = _interopRequireDefault(require("react"));
var AccessibleIcon = _interopRequireWildcard(require("@radix-ui/react-accessible-icon"));
var _Icons = require("../Icons.constants");
var _IconModule = _interopRequireDefault(require("../Icon.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var IconShield3 = _ref => {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? _Icons.DEFAULT_LABEL : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _Icons.DEFAULT_COLOR : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _Icons.DEFAULT_SIZE : _ref$size,
    _ref$isFilled = _ref.isFilled,
    isFilled = _ref$isFilled === void 0 ? false : _ref$isFilled;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: size,
      width: size
    },
    className: (0, _classnames.default)(className, _IconModule.default.Container)
  }, /*#__PURE__*/_react.default.createElement(AccessibleIcon.Root, {
    label: label
  }, isFilled ? /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.0002 2.46146C11.0002 2.0736 11.0002 1.87967 10.9188 1.75503C10.8475 1.64599 10.7365 1.56907 10.6094 1.54063C10.4641 1.50812 10.2825 1.57621 9.91936 1.71239L5.59491 3.33395C4.97712 3.5646 4.43457 3.76715 4.01675 4.13537C3.65124 4.4575 3.36968 4.86379 3.19641 5.31914C2.99834 5.83965 2.99918 6.41877 3.00013 7.07821L3.00026 12.0001C3.00026 14.8267 4.53756 17.1833 6.19932 18.9145C7.27833 20.0386 8.51574 21.0553 9.8396 21.9052C10.1933 22.1322 10.3701 22.2458 10.5361 22.2338C10.6759 22.2238 10.8166 22.1469 10.9006 22.0347C11.0002 21.9015 11.0002 21.6825 11.0002 21.2445L11.0002 2.46146Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.0002 21.2445C13.0002 21.6825 13.0002 21.9015 13.0999 22.0347C13.1839 22.1469 13.3246 22.2238 13.4644 22.2339C13.6304 22.2458 13.8072 22.1323 14.1609 21.9052C15.4848 21.0553 16.7222 20.0386 17.8012 18.9145C19.463 17.1833 21.0003 14.8267 21.0003 12.0001L21.0004 7.0782C21.0014 6.41876 21.0022 5.83964 20.8041 5.31914C20.6309 4.86379 20.3493 4.4575 19.9838 4.13537C19.566 3.76715 19.0234 3.5646 18.4056 3.33394L14.0811 1.71237C13.718 1.57619 13.5364 1.5081 13.3911 1.54062C13.264 1.56906 13.153 1.64598 13.0817 1.75502C13.0002 1.87965 13.0002 2.07358 13.0002 2.46144L13.0002 21.2445Z",
    fill: color
  })) : /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 2.49999V21.5M20 12C20 16.9084 14.646 20.4784 12.698 21.6149C12.4766 21.744 12.3659 21.8086 12.2097 21.8421C12.0884 21.8681 11.9116 21.8681 11.7903 21.8421C11.6341 21.8086 11.5234 21.744 11.302 21.6149C9.35396 20.4784 4 16.9084 4 12V7.21759C4 6.41808 4 6.01833 4.13076 5.6747C4.24627 5.37113 4.43398 5.10027 4.67766 4.88552C4.9535 4.64243 5.3278 4.50207 6.0764 4.22134L11.4382 2.21067C11.6461 2.13271 11.75 2.09373 11.857 2.07827C11.9518 2.06457 12.0482 2.06457 12.143 2.07827C12.25 2.09373 12.3539 2.13271 12.5618 2.21067L17.9236 4.22134C18.6722 4.50207 19.0465 4.64243 19.3223 4.88552C19.566 5.10027 19.7537 5.37113 19.8692 5.6747C20 6.01833 20 6.41808 20 7.21759V12Z",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
exports.IconShield3 = IconShield3;
//# sourceMappingURL=IconShield3.js.map